import { ITooltipOptions } from '@/editor/types';

export const toolTipOptions: ITooltipOptions = {
  offset: 8,
  delay: { show: 300, hide: 100 },
  placement: 'bottom',
};
